<div
  class="context-menu-trigger"
  [ngStyle]="menuRootStyle"
  [matMenuTriggerFor]="menu"
></div>
<mat-menu #menu="matMenu" (closed)="onMenuClosed()">
  @if ((isHandset$ | async) && inbox()) {
    <button mat-menu-item disabled>{{ inbox()!.name }}</button>
    <mat-divider></mat-divider>
  }
  @if (hasAddPermissionsToInbox()) {
    <button mat-menu-item (click)="onClickImport()">
      <mat-icon>archive</mat-icon>
      <span transloco="IMPORT"></span>
    </button>
    @if (isGseConnected$ | async) {
      <button mat-menu-item (click)="onClickScan()">
        <mat-icon>scanner</mat-icon>
        <span transloco="IMPORT_SCAN"></span>
      </button>
    }
  }
</mat-menu>
